import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUserAccessTeam } from '../redux/slices/userAccessTeam';

const useUserTeam = (withEmail = true) => {
  const dispatch = useDispatch();
  const { teams } = useSelector((state) => state?.userAccessTeam);

  useEffect(() => {
    if (!teams?.length) {
      dispatch(fetchUserAccessTeam());
    }
  }, []);

  if (!withEmail) {
    return { teams };
  }

  return { teams: teams?.filter((team) => team?.isEmailPresent) };
};

export default useUserTeam;
